import { Radio } from 'components/elements'
import { Field } from 'formik'
import styled from 'styled-components'

const defaultProps = {}
const propTypes = {}

const StyledRadio = styled(Radio)``

export const FormRadio = ({ name, validate, required, ...rest }) => {
  const inputValidation = value => {
    if (!validate) {
      return required && !value && 'Required field'
    } else {
      return validate(value)
    }
  }

  return (
    <Field name={name} validate={inputValidation}>
      {({ field, form }) => (
        <StyledRadio
          id={name}
          {...field}
          onChange={form.handleChange}
          error={form.touched[name] && Boolean(form.errors[name])}
          helperText={form.touched[name] && form.errors[name]}
          disabled={form.isSubmitting}
          {...rest}
        />
      )}
    </Field>
  )
}

FormRadio.defaultProps = defaultProps
FormRadio.propTypes = propTypes

export default FormRadio
